module.exports = __webpack_public_path__ + "media/images/responsive/page_common/banner_stores/banner_stores_omiya@2x-24b49c813137b0ce12eb218bd6e15959.webp";